import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const getProducts = (params = {}) => api.get("/products", { params }).then((r) => r.data);
export const getProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const subscribeNewsletter = (email) => api.post("/newsletter", { email }).then((r) => r.data);
export const sendContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const joinDropList = (payload) => api.post("/droplist", payload).then((r) => r.data);
export const getDropListCount = () => api.get("/droplist/count").then((r) => r.data);
export const placeOrder = (payload) => api.post("/orders", payload).then((r) => r.data);

// ---- Auth / account ----
export const authMe = () => api.get("/auth/me").then((r) => r.data);
export const authLogin = (email, password) => api.post("/auth/login", { email, password }).then((r) => r.data);
export const authRegister = (payload) => api.post("/auth/register", payload).then((r) => r.data);
export const authSession = (session_id) => api.post("/auth/session", { session_id }).then((r) => r.data);
export const authLogout = () => api.post("/auth/logout").then((r) => r.data);
export const updateProfile = (payload) => api.put("/auth/profile", payload).then((r) => r.data);
export const changePassword = (payload) => api.put("/auth/password", payload).then((r) => r.data);
export const updatePreferences = (payload) => api.put("/auth/preferences", payload).then((r) => r.data);
export const updateNotifications = (payload) => api.put("/auth/notifications", payload).then((r) => r.data);
export const toggleWishlist = (slug) => api.post(`/auth/wishlist/${slug}`).then((r) => r.data);
export const getWishlistCounts = () => api.get("/wishlist/counts").then((r) => r.data);
export const deleteAccount = () => api.delete("/auth/account").then((r) => r.data);
export const uploadAvatar = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/auth/avatar", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
